// src/pages/Features.jsx
import React from 'react';
import './Features.css';

function Features() {
  const features = [
    {
      icon: '💬',
      title: 'Natural Conversation',
      description: 'Just chat naturally—no forms, no confusion. Tell us what you want and we\'ll handle the rest.',
      highlight: 'AI-Powered'
    },
    {
      icon: '📈',
      title: 'Price Predictions',
      description: 'AI forecasts tell you when prices will rise or drop, so you always book at the right time.',
      highlight: 'Save Money'
    },
    {
      icon: '😴',
      title: 'Jet Lag Optimizer',
      description: 'Get personalized tips to beat jet lag based on your specific flight and time zones.',
      highlight: 'Travel Better'
    },
    {
      icon: '⚡',
      title: 'Instant Results',
      description: 'Search hundreds of flights in seconds with smart filters that learn your preferences.',
      highlight: 'Fast'
    },
    {
      icon: '🔒',
      title: 'Secure Booking',
      description: 'Book directly with airlines through our secure platform. No hidden fees, ever.',
      highlight: 'Trusted'
    },
    {
      icon: '💡',
      title: 'Smart Suggestions',
      description: 'Not sure where to go? Our AI suggests destinations based on your budget and interests.',
      highlight: 'Personalized'
    },
    {
      icon: '🌍',
      title: '200+ Airlines',
      description: 'Access flights from over 200 airlines worldwide, all in one place.',
      highlight: 'Global'
    },
    {
      icon: '📱',
      title: 'Works Everywhere',
      description: 'Search and book from any device—desktop, tablet, or mobile.',
      highlight: 'Responsive'
    },
    {
      icon: '🎯',
      title: 'Flexible Dates',
      description: 'Find the cheapest days to fly with our flexible date search.',
      highlight: 'Flexible'
    }
  ];

  return (
    <div className="features-page">
      {/* Header */}
      <header className="features-header">
        <div className="features-header-content">
          <a href="/" className="features-logo">
            <img src="/logo.png" alt="Airgati" className="features-logo-img" />
          </a>
          <nav className="features-nav">
            <a href="/features" className="active">Features</a>
            <a href="/pricing">Pricing</a>
          </nav>
          <a href="/" className="features-back-btn">← Back to Search</a>
        </div>
      </header>

      {/* Hero */}
      <section className="features-hero">
        <h1>Everything you need to book smarter</h1>
        <p>Powerful features designed to save you time and money on every flight.</p>
      </section>

      {/* Features Grid */}
      <section className="features-container">
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-item">
              <div className="feature-item-header">
                <span className="feature-item-icon">{feature.icon}</span>
                <span className="feature-item-highlight">{feature.highlight}</span>
              </div>
              <h3 className="feature-item-title">{feature.title}</h3>
              <p className="feature-item-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="features-cta">
        <h2>Ready to book smarter?</h2>
        <p>Try Airgati free—no credit card required.</p>
        <a href="/" className="features-cta-btn">Start Searching →</a>
      </section>

      {/* Footer */}
      <footer className="features-footer">
        <p>© 2025 Airgati. All rights reserved.</p>
        <div className="features-footer-links">
          <a href="/privacy-policy">Privacy</a>
          <a href="/terms">Terms</a>
          <a href="/disclaimer">Disclaimer</a>
        </div>
      </footer>
    </div>
  );
}

export default Features;
